/*
 * Lichcards — winkelwagen
 * <lc-free-shipping> : gratis-verzendbalk die meebeweegt met de winkelwagen.
 *
 * Werkt zonder Ella's `show_calculator_free_shipping_message`-instelling.
 */
(function () {
  'use strict';

  var SHOP_CURRENCY = 'EUR';

  /* ---------- helpers ---------- */

  function activeCurrency() {
    try {
      return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || SHOP_CURRENCY;
    } catch (e) {
      return SHOP_CURRENCY;
    }
  }

  // Rekent een bedrag in centen (shopvaluta) om naar de actieve valuta.
  function convertCents(cents) {
    var active = activeCurrency();
    if (active === SHOP_CURRENCY) return cents;
    try {
      if (window.Currency && typeof window.Currency.convert === 'function') {
        return Math.round(window.Currency.convert(cents, SHOP_CURRENCY, active));
      }
    } catch (e) {
      /* stil falen: liever de onomgerekende waarde dan een kapotte balk */
    }
    return cents;
  }

  function formatMoney(cents) {
    var rounded = Math.round(cents);
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.money_format) {
        return window.Shopify.formatMoney(rounded, window.money_format);
      }
    } catch (e) {
      /* val terug op Intl */
    }
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', {
        style: 'currency',
        currency: activeCurrency(),
      }).format(rounded / 100);
    } catch (e) {
      return '€ ' + (rounded / 100).toFixed(2).replace('.', ',');
    }
  }

  var cartRequest = null;
  function getCart() {
    // Bundelt gelijktijdige aanvragen tot één fetch.
    if (cartRequest) return cartRequest;
    cartRequest = fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart.js'
      : '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .finally(function () {
        setTimeout(function () { cartRequest = null; }, 0);
      });
    return cartRequest;
  }

  /* ---------- teksten ---------- */

  // De zichtbare zinnen komen als data-attribuut mee vanuit
  // snippets/lichcards-free-shipping.liquid, zodat de server en dit script
  // exact dezelfde vertaling gebruiken. Ontbreekt het attribuut, dan valt de
  // zin terug op het Nederlands hieronder.
  var T_FALLBACK = {
    idle: 'Gratis verzending vanaf {amount}',
    complete: 'Gelukt — je verzending is {free}',
    free: 'gratis',
    remaining: 'Nog {amount} en je verzending is gratis',
    saved: 'Je bespaart {amount} verzendkosten',
    rate: 'Verzending {amount} tot {threshold}'
  };

  function readTexts(el) {
    var d = (el && el.dataset) || {};
    return {
      idle: d.tIdle || T_FALLBACK.idle,
      complete: d.tComplete || T_FALLBACK.complete,
      free: d.tFree || T_FALLBACK.free,
      remaining: d.tRemaining || T_FALLBACK.remaining,
      saved: d.tSaved || T_FALLBACK.saved,
      rate: d.tRate || T_FALLBACK.rate
    };
  }

  // Vult {amount}, {threshold} en {free} in een zin in.
  function fill(template, values) {
    return template.replace(/\{(amount|threshold|free)\}/g, function (match, name) {
      return values[name] == null ? match : values[name];
    });
  }

  /* ---------- gratis-verzendbalk ---------- */

  class LcFreeShipping extends HTMLElement {}

  LcFreeShipping.prototype.connectedCallback = function () {
    this.threshold = convertCents(parseInt(this.dataset.threshold, 10) || 7500);
    this.rate = convertCents(parseInt(this.dataset.rate, 10) || 0);
    this.msgEl = this.querySelector('[data-lc-msg]');
    this.footEl = this.querySelector('[data-lc-foot]');
    this.fillEl = this.querySelector('[data-lc-fill]');
    this.riderEl = this.querySelector('[data-lc-rider]');
    this.trackEl = this.querySelector('[data-lc-track]');
    this.goalEl = this.querySelector('.lc-fs__goal');
    this.wasComplete = this.classList.contains('is-complete');
    this.t = readTexts(this);

    if (this.goalEl) this.goalEl.textContent = formatMoney(this.threshold);

    this.onCartUpdated = this.refresh.bind(this);
    document.addEventListener('cart:updated', this.onCartUpdated);
    document.addEventListener('cart:refresh', this.onCartUpdated);

    try {
      if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
        this.unsubscribe = window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, this.onCartUpdated);
      }
    } catch (e) {
      /* geen pub/sub in dit thema — de DOM-events volstaan */
    }

    // De server rendert de juiste begintoestand al, dus alleen verversen
    // wanneer de winkelwagen daarna nog verandert. Eén controle na de eerste
    // paint vangt caching / terug-navigatie op.
    var self = this;
    setTimeout(function () { self.refresh(); }, 300);
  };

  LcFreeShipping.prototype.disconnectedCallback = function () {
    document.removeEventListener('cart:updated', this.onCartUpdated);
    document.removeEventListener('cart:refresh', this.onCartUpdated);
    if (typeof this.unsubscribe === 'function') this.unsubscribe();
  };

  LcFreeShipping.prototype.refresh = function () {
    var self = this;
    getCart()
      .then(function (cart) { self.render(cart ? cart.total_price || 0 : 0); })
      .catch(function () { /* winkelwagen niet op te halen: laat de huidige stand staan */ });
  };

  LcFreeShipping.prototype.render = function (total) {
    var threshold = this.threshold;
    var remaining = Math.max(threshold - total, 0);
    var pct = total > 0 ? Math.min((total / threshold) * 100, 100) : 0;
    var state = total === 0 ? 'idle' : remaining === 0 ? 'complete' : 'partial';

    this.classList.toggle('is-idle', state === 'idle');
    this.classList.toggle('is-partial', state === 'partial');
    this.classList.toggle('is-complete', state === 'complete');

    if (this.fillEl) this.fillEl.style.width = pct + '%';
    if (this.riderEl) this.riderEl.style.left = pct + '%';
    if (this.trackEl) this.trackEl.setAttribute('aria-valuenow', String(Math.round(pct)));

    var t = this.t || readTexts(this);

    if (this.msgEl) {
      if (state === 'idle') {
        this.msgEl.innerHTML = fill(t.idle, { amount: '<strong>' + formatMoney(threshold) + '</strong>' });
      } else if (state === 'complete') {
        this.msgEl.innerHTML = fill(t.complete, { free: '<strong>' + t.free + '</strong>' });
      } else {
        this.msgEl.innerHTML = fill(t.remaining, { amount: '<strong>' + formatMoney(remaining) + '</strong>' });
      }
    }

    if (this.footEl) {
      this.footEl.textContent = state === 'complete'
        ? fill(t.saved, { amount: formatMoney(this.rate) })
        : fill(t.rate, { amount: formatMoney(this.rate), threshold: formatMoney(threshold) });
    }

    if (state === 'complete' && !this.wasComplete) this.celebrate();
    this.wasComplete = state === 'complete';
  };

  LcFreeShipping.prototype.celebrate = function () {
    var self = this;
    this.classList.remove('lc-fs--pop');
    // forceer een reflow zodat de animatie opnieuw start
    void this.offsetWidth;
    this.classList.add('lc-fs--pop');
    setTimeout(function () { self.classList.remove('lc-fs--pop'); }, 1600);
  };

  /* ---------- opstarten ---------- */

  function init() {
    if (!window.customElements.get('lc-free-shipping')) {
      window.customElements.define('lc-free-shipping', LcFreeShipping);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
